(function () {
  var esc = function (value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (match) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[match];
    });
  };

  var cardHtml = function (item) {
    var media = item.image
      ? '<img class="aw-favorites-list__image" src="' + esc(item.image) + '" alt="' + esc(item.imageAlt || item.title) + '" loading="lazy">'
      : '';
    var meta = item.meta ? '<p class="aw-favorites-list__meta">' + esc(item.meta) + '</p>' : '';
    var title = item.title ? '<p class="aw-favorites-list__title">' + esc(item.title) + '</p>' : '';
    var link = item.url ? '<a class="aw-favorites-list__link" href="' + esc(item.url) + '">' + media + '<div class="aw-favorites-list__body">' + meta + title + '</div></a>' : '<div class="aw-favorites-list__link">' + media + '<div class="aw-favorites-list__body">' + meta + title + '</div></div>';

    return '<div class="aw-favorites-list__card">' +
      link +
      '<button type="button" class="aw-favorites-list__remove" data-aw-favorites-remove data-favorite-type="' + esc(item.type) + '" data-favorite-handle="' + esc(item.handle) + '">削除</button>' +
      '</div>';
  };

  var TYPES = ['style', 'nail'];

  function initFavoritesList(root) {
    var groups = {};
    TYPES.forEach(function (type) {
      groups[type] = {
        wrap: root.querySelector('[data-aw-favorites-group="' + type + '"]'),
        grid: root.querySelector('[data-aw-favorites-grid="' + type + '"]')
      };
    });
    var emptyEl = root.querySelector('[data-aw-favorites-empty]');
    if (!groups.style.grid && !groups.nail.grid) return;

    var renderGroup = function (type, items) {
      var group = groups[type];
      if (!group.grid) return;

      if (!items.length) {
        if (group.wrap) group.wrap.hidden = true;
        group.grid.innerHTML = '';
        return;
      }

      if (group.wrap) group.wrap.hidden = false;
      group.grid.innerHTML = items.map(cardHtml).join('');

      Array.prototype.forEach.call(group.grid.querySelectorAll('[data-aw-favorites-remove]'), function (button) {
        button.addEventListener('click', function () {
          window.awFavorites.remove(button.dataset.favoriteType, button.dataset.favoriteHandle);
          render();
        });
      });
    };

    var render = function () {
      if (!window.awFavorites) return;
      var items = window.awFavorites.read();

      if (emptyEl) emptyEl.hidden = items.length > 0;

      TYPES.forEach(function (type) {
        renderGroup(type, items.filter(function (item) { return item.type === type; }));
      });
    };

    render();
    document.addEventListener('aw:favorites-changed', render);
    window.addEventListener('storage', function (event) {
      if (event.key === 'aw-favorites') render();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.forEach.call(document.querySelectorAll('.aw-favorites-list'), initFavoritesList);
  });
})();
